exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-primary-and-other-files-selector{margin-bottom:10px}.c-primary-and-other-files-selector_label{color:#112363;padding-bottom:10px}.c-primary-and-other-files-selector_drop_zone{border:1px solid #d9d9d9;padding:10px}", ""]);

// exports
